import { InnerBlocks, useBlockProps } from '@wordpress/block-editor';

import { blockColumns } from './templates';

const INNER_BLOCKS_TEMPLATE = [
	blockColumns
];

const ALLOWED_BLOCKS_INNER_BLOCKS = [ 'core/group' ];


const Edit = () => {
	const blockProps = useBlockProps();
	return (
		<div { ...blockProps } className='alignfull'>
		<InnerBlocks
			template={ blockColumns }
			
			className='alignfull'
			
			
			
		/>
		</div>
	)
};
export default Edit;
